import { DrinkingDays } from "./types";
import { DrinkingDay, DrinksPerDay } from "@dcc/types/drinkingDay";

export const sumDrinksForDay = (day: DrinkingDay): number =>
  Object.values(day).reduce((agg, curr) => (agg += curr), 0);

export const drinksPerDayOfweek = (days: DrinkingDays): DrinksPerDay[] =>
  Object.keys(days).map((d) => {
    const day = Number(d);
    return {
      day,
      ...days[day],
      amount: sumDrinksForDay(days[day])
    };
  });
